import React from "react";
// Import react-date-range base styles (needed for DateRangePicker styling)
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { AuthProvider } from "./context/AuthContext";
import AppRoutes from "./Routes";
import GlobalStyle from "./styles/globalStyles";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function App() {
    return (
        <AuthProvider>
            <ToastContainer />
            <GlobalStyle />
            <AppRoutes />
        </AuthProvider>
    );
}
export default App;
